import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { Moon, Sun, TrendingUp } from "lucide-react";
import { useTheme } from "@/hooks/useTheme";

export default function Navbar() {
  const { theme, toggle } = useTheme();
  const location = useLocation();
  const onAdmin = location.pathname.startsWith("/admin");

  return (
    <motion.header
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.4 }}
      className="sticky top-0 z-40 w-full backdrop-blur-xl bg-white/70 dark:bg-black/60 border-b border-border"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 h-16 flex items-center justify-between">
        <Link
          to="/"
          data-testid="navbar-logo"
          className="flex items-center gap-2 group"
        >
          <div className="w-8 h-8 rounded-lg bg-primary/10 border border-primary/20 flex items-center justify-center">
            <TrendingUp className="w-4 h-4 text-primary" />
          </div>
          <span className="font-display text-lg font-semibold tracking-tight">
            MethodA
          </span>
          <span className="hidden sm:inline text-xs text-muted-foreground font-medium ml-1">
            Trading Health
          </span>
        </Link>

        <nav className="flex items-center gap-2 sm:gap-4">
          {!onAdmin && (
            <Link
              to="/assessment"
              data-testid="navbar-start-assessment"
              className="hidden sm:inline text-sm font-medium text-foreground/80 hover:text-foreground transition"
            >
              Take assessment
            </Link>
          )}
          <Link
            to={onAdmin ? "/" : "/admin/login"}
            data-testid="navbar-admin-link"
            className="text-sm font-medium text-foreground/80 hover:text-foreground transition"
          >
            {onAdmin ? "Exit" : "Admin"}
          </Link>
          <button
            onClick={toggle}
            aria-label="Toggle theme"
            data-testid="theme-toggle-btn"
            className="w-9 h-9 rounded-lg border border-border flex items-center justify-center hover:bg-accent transition"
          >
            {theme === "dark" ? (
              <Sun className="w-4 h-4" />
            ) : (
              <Moon className="w-4 h-4" />
            )}
          </button>
        </nav>
      </div>
    </motion.header>
  );
}
